<template>
  <div class="h-full">
    <div class="flex h-full justify-end items-center">
      <vs-dropdown
        style="margin-left: 5px; cursor: pointer"
        vs-custom-content
        vs-trigger-click
      >
        <vs-button
          color="primary"
          type="border"
          icon-pack="feather"
          icon="icon-more-vertical"
        ></vs-button>

        <vs-dropdown-menu style="min-width: 100px">
          <vs-dropdown-item @click="openEditView(params.data)"
            >Edit</vs-dropdown-item
          >
          <vs-dropdown-item @click="openConfirm()">Delete</vs-dropdown-item>
          <vs-dropdown-item @click="openPreview()"
            >Preview</vs-dropdown-item
          >
           <vs-dropdown-item @click="noteAssignModal = true"
            >Assign</vs-dropdown-item
          >

          <vs-dropdown-item @click="attachToCourseModal = true"
            >Attach to Course</vs-dropdown-item
          >
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
    <div v-if="noteAssignModal">
      <NoteAssignComponent
        v-if="noteAssignModal"
        :note_id="params.data.id"
        :noteAssignModal="noteAssignModal"
        @closeAssignmentModal="closeAssignmentModal"
      />
    </div>
    <div v-if="attachToCourseModal">
      <NoteAttachtoCourse
        :note_id="params.data.id"
        :attachToCourseModal="attachToCourseModal"
        @attachToCourseModalFalse="attachToCourseModalFalse"
      />
    </div>
  </div>
</template>

<script>
import { deleteNoteTemplate } from '@/api/lesson_notes.js'
import NoteAssignComponent from '@/views/pages/v1/notes/components/noteAssignComponent.vue'
import NoteAttachtoCourse from '@/views/pages/v1/notes/components/Template/attachedToCourseNote.vue'

export default {
  name: 'CellRendererAction',
  data () {
    return {
      noteAssignModal: false,
      attachToCourseModal: false
    }
  },
  mounted () {},
  components: {
    NoteAssignComponent,
    NoteAttachtoCourse
  },
  methods: {
    attachToCourseModalFalse () {
      this.attachToCourseModal = false
      this.params.colDef.filterParams.fetchNotesTemplate()
    },
    closeAssignmentModal (data) {
      this.noteAssignModal = data
    },
    openConfirm () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Please Confirm',
        text: 'Are you sure, you want to delete this template?',
        accept: this.acceptAlert
      })
    },
    acceptAlert () {
      this.deleteAssignment()
    },
    async deleteAssignment () {
      try {
        const customer_id = this.$store.getters.customerId

        await deleteNoteTemplate(customer_id, this.params.data.id)

        this.showSuccessMessage('Success', 'Deleted Successfully', 'success')
        this.params.colDef.filterParams.fetchNotesTemplate()
      } catch (error) {
        console.log(error)
      }
    },
    openEditView () {
      this.params.colDef.filterParams.openEditView(this.params.data)
    },
    openPreview () {
      this.params.colDef.filterParams.openPreview(this.params.data)
    }
  }
}
</script>
